import { createGlobalStyle, css } from 'styled-components'

export default createGlobalStyle`

:root {
        --main-bg-color: #3C97F7;
        --nav-bg-color: #f1f2f5;
        --nav-text-color: #78858e;
        --text-color: #434343;
        --highlight-color: #f8632a;

        --header-height: 3.8rem;
        --expanded-sidebar-width: 256px;
        --collapsed-sidebar-width: 88px;

        --fg-0: #41424c;
        --fg-1: #7a7b82;
        --fg-2: #9fa0a5;
        --fg-3: #bcbdc0;
        --fg-4: #d9d9db;

        --bg-0: #eff1f5;
        --bg-1: #f9f9f9;
        --bg-2: #fafafa;
        --bg-3: #fcfcfc;
        --bg-4: #fdfdfd;


        --layout-border: #d9d9db;

        --primary-color-00: #0A77EB;
        --primary-color-0: #1481F5;

        --primary-color: #3C97F7;
        --primary-color-2: #62ABF8;
        --primary-color-3: #89C0FA;
        --primary-color-4: #B1D5FC;
        --primary-color-5: #D8EAFD;

        --secondary-color: #89C0FA;
        --secondary-color-2: #ff9332;
        --secondary-color-3: #ffae65;
        --secondary-color-4: #ffc999;
        --secondary-color-5: #fee4cc;

        --btn-main-action: var(--primary-color);
        --btn-main-action-active: var(--secondary-color);

        --critical-0: #fd5540;
        --critical-1: #fe8779;
        --critical-2: #fea99f;
        --critical-3: #ffc3bc;
        --critical-4: #ffddd9;

        --success-0: #30bf20;
        --success-3: #e3ffe9;


        --info-0: #0199cc;
        --warning-0: #ffa034;

        --graphic-red: #FCC;
        --graphic-yellow: #FAEFB2;
        --graphic-green: #E1FCCC;
        --graphic-default: #ccc;

        --icon-xxs: 0.75rem;
        --icon-xs: 1rem;
        --icon-sm: 1.25rem;
        --icon-md: 1.5rem;
        --icon-lg: 2rem;
        --icon-xl: 2.5rem;
    }

.breadcrumb-separator {
    flex-shrink: 0;
    height: 1.1rem;
    width: 0.9rem;
    margin-left: 0.8rem;
    margin-right: 0.8rem;
}

@keyframes pulse-light {
 0% {
        background-color: var(--blueish-50);
        opacity: 0.5;
    };
 100% { background-color: var(--blueish-50)};
}

@keyframes pulse-dark {
 0% {
        background-color: var(--blueish-200);
        opacity: 0.5;
    };
 100% { background-color: var(--blueish-200)};
}

.interaction-icon {
    height: 2rem;
    width: 2rem;
}

a {
    text-decoration: none;
    color: var(--fg-0);
}

body {
    // background-color: var(--main-bg-color);
    overflow: hidden;

    margin: 0;
    font-family: 'Fira Sans', 'Noto Color Emoji', sans-serif;
    font-variant-ligatures: none;
    font-size: 14px;
    padding: 0;
    height: 100%;

    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}
html, #root{
    height: 100%;
}

.hidden-on-mobile {
    @media (max-width: 768px) {
        display: none;
    }
}

.hidden-on-tablet {
    @media (max-width: 1024px) {
        display: none;
    }
}


*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
 
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px var(--blueish-50);
}
 
*::-webkit-scrollbar-thumb {
  background-color: var(--blueish-400);
  outline: 1px solid var(--blueish-400);
}

.rotate-animated {
  transition: transform 0.2s ease-in-out;
}

${[-270, -180, -90, 90, 180, 270].map(
  (deg) => css`
    .rotate-${deg} {
      transform: rotate(${deg}deg);
    }
    .rotate-icon-${deg} svg {
      transform: rotate(${deg}deg);
    }
  `,
)}
`
